/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type IncomeAmountAmountType = (typeof IncomeAmountAmountType)[keyof typeof IncomeAmountAmountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncomeAmountAmountType = {
  employment: "employment",
  self_employment: "self_employment",
  rental: "rental",
  parental: "parental",
  pension: "pension",
  first_degree_disability: "first_degree_disability",
  second_degree_disability: "second_degree_disability",
  third_degree_disability: "third_degree_disability",
  orphan_pension: "orphan_pension",
  widow_pension: "widow_pension",
  other: "other",
} as const;
